import { render, staticRenderFns } from "./ProjectTypes.vue?vue&type=template&id=7a71a9c4&"
import script from "./ProjectTypes.vue?vue&type=script&lang=ts&"
export * from "./ProjectTypes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports